import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../translate/localization";
import CobeeTextField from "../../../../../app/components/CobeeTextField";
import useStyles from "../../styles";

export default function RowPurchasePrice({ purchasePrice, setPurchasePrice }) {
  const { secondColumn, fieldRowSpacing, inputLabel } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.purchase-price")}:
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        alignItems="center"
        className={`${secondColumn} ${fieldRowSpacing}`}
      >
        <Grid item xs={4}>
          <CobeeTextField
            type="number"
            minWidth="100%"
            min={0}
            value={purchasePrice}
            onChange={(e) => setPurchasePrice(e.target.value)}
          />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2" className={inputLabel}>
            {`EUR (${t("common-messages.tax-included")})`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

RowPurchasePrice.propTypes = {
  purchasePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setPurchasePrice: PropTypes.func,
};

RowPurchasePrice.defaultProps = {
  purchasePrice: "0",
  setPurchasePrice: () => {},
};
